import { KeyStructuredStorageBaseHelper } from './KeyStructuredStorageBaseHelper';
export class GetStructuredStorageHelper extends KeyStructuredStorageBaseHelper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.getKeyStructuredStorage({ type: this.type, keyType: this.keyType, knownKeyType: this.knownKeyType }));
        sb.emitHelper(node, options, sb.helpers.getStorage);
        sb.emitHelper(node, options, sb.helpers.handleUndefinedStorage({
            handleUndefined: () => {
                sb.emitHelper(node, options, sb.helpers.wrapUndefined);
            },
            handleDefined: () => {
                sb.emitSysCall(node, 'Neo.Runtime.Deserialize');
                sb.emitPushInt(node, 1);
                sb.emitOp(node, 'PICKITEM');
            },
        }));
        if (!optionsIn.pushValue) {
            sb.emitOp(node, 'DROP');
        }
    }
}

//# sourceMappingURL=GetStructuredStorageHelper.js.map
